export default __webpack_public_path__ + "static/media/yogapose.1161dbdc.png";